<header>
  <div class="top_header">
    <div class="container">
      <div class="top_header_child">
        <a routerLink="/" class="logo"
          ><img loading="lazy" src="../../../assets/images/header/logo.svg"
        /></a>
        <div class="e_wh_l">
          <a href="tel:8606443030" class="img_cnt">
            <img loading="lazy" src="assets/images/header/call.svg" alt="" />
            <div class="h6_p">
              <h6>Emergency</h6>
              <span>86064 43030</span>
              <!-- ✅ Replaced nested <a> with <span> -->
            </div>
          </a>
          <div class="img_cnt wh">
            <img loading="lazy" src="assets/images/header/clock.svg" alt="" />
            <div class="h6_p">
              <h6>Work Hour</h6>
              <p>08:30 AM - 05:00 PM Everyday</p>
            </div>
          </div>
          <a
            href="https://maps.app.goo.gl/xzuphzMVGpbUpFwU9"
            target="_blank"
            class="img_cnt"
          >
            <img
              loading="lazy"
              src="assets/images/header/location.svg"
              alt=""
            />
            <div class="h6_p">
              <h6>Location</h6>
              <span>Kannur, Kerala 670001</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom_header">
    <div class="container">
      <div class="bottom_header_child">
        <nav class="navbar navbar-expand-lg">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  class="nav-link"
                  aria-current="page"
                  [routerLink]="['/']"
                  >Home</a
                >
              </li>
              <li class="nav-item">
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  class="nav-link"
                  [routerLink]="['./aboutus']"
                  >About</a
                >
              </li>
              <li class="nav-item treatments_dd">
                <a class="nav-link" (click)="toggleMainDropdown()"
                  >Treatments and Procedures&nbsp;<i
                    class="fa-solid fa-angle-down"
                  ></i
                ></a>
                <ul class="main_t_dd" *ngIf="isMainDropdownOpen">
                  <li (mouseenter)="openSubDropdown()">
                    Treatments
                    <ul *ngIf="isSubDropdownOpen">
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./ovulation-induction']"
                      >
                        Ovulation Induction
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./intrauterine-insemination']"
                      >
                        Intrauterine Insemination (IUI)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./in-vitro-fertilization']"
                      >
                        In Vitro Fertilization (IVF)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./intracytoplasmic-sperm-injection']"
                      >
                        Intracytoplasmic Sperm Injection (ICSI)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./pre-implantation-genetic-testing']"
                      >
                        Pre Implantation Genetic Testing (PGT)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./recurrent-implantation-failure']"
                      >
                        Recurrent Implantation Failure (RIF)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./recurrent-pregnancy-loss']"
                      >
                        Recurrent Pregnancy Loss ( RPL)
                      </li>
                      <li
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        href="#"
                        [routerLink]="['./witnessing-system']"
                      >
                        Witnessing System
                      </li>
                    </ul>
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./fertility-preservation']"
                  >
                    Freezing & Preservation
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./advance-procedures-techniques']"
                  >
                    Advanced Procedures & Techniques
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./sperm-retrieval-techniques']"
                  >
                    Sperm Retrieval Techniques
                  </li>
                </ul>
              </li>
              <li class="nav-item fetal_medicine_dd">
                <a class="nav-link"
                  >Fetal Medicine&nbsp;<i class="fa-solid fa-angle-down"></i
                ></a>
                <ul class="main_t_dd">
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./prenatal-scans']"
                  >
                    Prenatal Scan
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./fetal-medicine-scans']"
                  >
                    Antenatal scans
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./antenatal-interventions']"
                  >
                    Antenatal Interventions
                  </li>
                  <li
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    [routerLink]="['./fetal-therapy']"
                  >
                    Fetal Therapy
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['./medical-team']"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  >Our Team</a
                >
              </li>
              <li
                class="nav-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
              >
                <a class="nav-link" [routerLink]="['./photo-gallery']"
                  >Gallery</a
                >
              </li>
              <li
                class="nav-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
              >
                <a class="nav-link" href="" [routerLink]="['./page/blogs']"
                  >Blogs</a
                >
              </li>
            </ul>
          </div>
        </nav>
        <a
          class="book_appointment"
          href="#"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          [routerLink]="['./contact-us']"
          >Contact Us</a
        >
      </div>
    </div>
  </div>
</header>

<div
  class="modal fade"
  id="menuModel"
  tabindex="-1"
  aria-labelledby="menu-tab"
  aria-hidden="true"
>
  <div class="modal-dialog"></div>
</div>
